module.exports = __webpack_public_path__ + "img/novelty-insurance.63ba22ca.png";